import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {vtmT} from '../i18n';
import '../../styles/vtm/roll.css';
import '../../styles/vtm/campaigns.css';

/** Formulaire d'une ligne : champ + bouton, pour rejoindre ou fonder une campagne. */
const InlineForm = ({id, label, placeholder, action, value, onChange, onSubmit, primary}) => (
  <form className="vtmCampaignForm" onSubmit={event => { event.preventDefault(); if (value.trim()) onSubmit(value.trim()); }}>
    <label className="vtmCampaignFormLabel" htmlFor={id}>{label}</label>
    <div className="vtmCampaignFormRow">
      <input id={id} type="text" placeholder={placeholder} value={value} onChange={event => onChange(event.target.value)} autoComplete="off" />
      <button type="submit" className={`vtmButton${primary ? ' primary' : ''}`} disabled={!value.trim()}>{action}</button>
    </div>
  </form>
);

/**
 * Liste des campagnes VtM : une ligne par campagne (favorites en tête), puis rejoindre / fonder.
 * Les données et l'écriture Firebase restent dans containers/Campaigns.js.
 */
const VtmCampaignList = ({campaigns, favorites, userUid, baseUrl, onSelect, onToggleFavorite, joinCode, onJoinCodeChange, onJoin, onCreate}) => {
  const [newName, setNewName] = useState('');
  const isEmpty = campaigns.length === 0;
  const sorted = [...campaigns].sort((a, b) => (favorites.includes(b.uid) - favorites.includes(a.uid)) || (a.name || '').localeCompare(b.name || ''));

  return (
    <div className="vtmCampaigns">
      <div className="vtmCampaignsHeader">
        <h1 className="vtmCampaignsTitle">{vtmT('myCampaigns')}</h1>
        {!isEmpty && <p className="vtmCampaignsCount">{vtmT('campaignCount', {value: campaigns.length})}</p>}
      </div>

      {isEmpty ? (
        <p className="vtmCampaignsEmpty">{vtmT('noCampaignYet')}</p>
      ) : (
        <ul className="vtmCampaignList">
          {sorted.map(campaign => {
            const isDm = campaign.idUserDm === userUid;
            const isFavorite = favorites.includes(campaign.uid);
            return (
              <li key={campaign.uid} className={`vtmCampaignRow${isFavorite ? ' favorite' : ''}`}>
                <Link className="vtmCampaignLink" to={`${baseUrl}/${campaign.uid}`} onClick={() => onSelect(campaign)}>
                  <span className="vtmCampaignName">{campaign.name}</span>
                  <span className="vtmCampaignMeta">
                    <span className={`vtmCampaignRole${isDm ? ' dm' : ''}`}>{isDm ? vtmT('dm') : vtmT('playerOf')}</span>
                    {isDm && campaign.invitationCode && (
                      <span className="vtmCampaignCode">{vtmT('invitationCode')} · <strong>{campaign.invitationCode}</strong></span>
                    )}
                  </span>
                </Link>
                <button
                  type="button"
                  className={`vtmCampaignFav${isFavorite ? ' active' : ''}`}
                  onClick={event => onToggleFavorite(event, campaign.uid)}
                  aria-pressed={isFavorite}
                  aria-label={vtmT('favorite')}
                  title={vtmT('favorite')}
                >
                  ★
                </button>
              </li>
            );
          })}
        </ul>
      )}

      <section className={`vtmCampaignForms${isEmpty ? ' prominent' : ''}`} aria-label={vtmT('newCampaignSection')}>
        <InlineForm
          id="vtmJoinCode"
          label={vtmT('joinCampaign')}
          placeholder={vtmT('invitationCode')}
          action={vtmT('join')}
          value={joinCode}
          onChange={onJoinCodeChange}
          onSubmit={onJoin}
          primary={isEmpty}
        />
        <InlineForm
          id="vtmNewCampaign"
          label={vtmT('createCampaign')}
          placeholder={vtmT('campaignName')}
          action={vtmT('create')}
          value={newName}
          onChange={setNewName}
          onSubmit={onCreate}
          primary={isEmpty}
        />
      </section>
    </div>
  );
};

export default VtmCampaignList;
